import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getGroupTemplate (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return await new Promise((resolve, reject) => {
      const data = mock.getGrouptemplate

      const clone = JSON.parse(JSON.stringify(data))
      let response = clone.default
      if (params.idCliente) {
        response = clone.respuesta.find(x => x.IdCliente === params.idCliente) || clone.default
      }
      clone.respuesta = response
      delete clone.default
      delete clone.meta
      delete clone.links

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/plantillas/getplantillagrupo',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getGroupTemplate }
